import * as React from "react";
import { RouteComponentProps } from "react-router-dom";

import { ROUTE_NAMES } from '@bakbak/common';
import { LoginController, LoginMutation_login_user } from '@bakbak/controller';

import { LoginView } from "./LoginView";
import { AppContextProps, withAppContext } from "../../../context/AppContext";

export class LoginC extends React.PureComponent<RouteComponentProps & AppContextProps> {

	onComplete = (user: LoginMutation_login_user | null) => {
		const { history, location: { state } } = this.props;
		if (user) {
			this.props.context.updateLoggedUser(user);
		}
		if (state && state.next) {
			return history.replace({ pathname: state.next });
		}
		history.push(ROUTE_NAMES.HOME);
	}
	onCancel = () => {
		this.props.history.push(ROUTE_NAMES.HOME);
	}
	async componentDidMount() {
		if (this.props.context.loggedUser) {
			this.props.history.push(ROUTE_NAMES.HOME);
		}
	}
	render() {
		return (
			<LoginController>
				{({ submit }: any) =>
					<LoginView
						onComplete={this.onComplete}
						onCancel={this.onCancel}
						submit={submit}
					/>}
			</LoginController>
		);
	}
}

export const LoginConnector = withAppContext(LoginC);



// WEBPACK FOOTER //
// ./src/modules/auth/login/LoginConnector.tsx